import { render } from "./TrackAndTrace.vue?vue&type=template&id=532b0997&scoped=true"
import script from "./TrackAndTrace.vue?vue&type=script&lang=js"
export * from "./TrackAndTrace.vue?vue&type=script&lang=js"

import "./TrackAndTrace.vue?vue&type=style&index=0&id=532b0997&scoped=true&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532b0997"]])

export default __exports__